<div>
    <p-dialog [(visible)]="quotationTemplateService.activateEditDialog" [modal]="true">
        <app-edit-quotation-template *ngIf="quotationTemplateService.activateEditDialog" [template]="selectedQuotationTemplate!" (updatedTemplate)="updateModifiedQuotationTemplate($event)"></app-edit-quotation-template>
    </p-dialog>
    <p-dialog header="Select Template" [(visible)]="displayQuotationTemplateDialog" [modal]="true"
    [style]="{ height: '100%' }">
        <div class="template-list-container">
            <table>
                <colgroup>
                    <col class="template-first-col">
                    <col class="template-second-col">
                    <col class="template-third-col">
                </colgroup>
                <tr>
                    <td>Name</td>
                    <td>Edit</td>
                    <td>Last modified</td>
                </tr>
            </table>
            <p-listbox [options]="quotationTemplates" [(ngModel)]="selectedQuotationTemplate"
                 optionLabel="name" [style]="{ height: '100%' }" [listStyle]="{'max-height': '100%'}">
                <ng-template let-template let-index="index" pTemplate="item">
                    <div [pTooltip]="quotationTemplateTooltips[index]" tooltipPosition="right">
                        <table>
                            <colgroup>
                                <col class="template-first-col">
                                <col class="template-second-col">
                                <col class="template-third-col">
                            </colgroup>
                            <tr>
                                <td (click)="setPreConfirmationFormValuesFromTemplate(template)">{{template.name}}</td>
                                <td><p-button icon="pi pi-file-edit" (onClick)="activateQuotationTemplateEditDialog(template)"></p-button></td>
                                <td>{{template.lastModified.toDate() | date: 'dd/MM/yyyy'}}</td>
                            </tr>
                        </table>
                    </div>
                </ng-template>
            </p-listbox>
            <p *ngIf="quotationTemplates.length==0">Template list is empty.</p>
        </div>
    </p-dialog>
    <p-dialog header="Save this quotation as template" [(visible)]="displayQuotationTemplateCreatingDialog"
        [modal]="true">
        <div>
            <p>
                Input the name of quotation template, then save.
            </p>
            <input pInputText [(ngModel)]="selectedQuotationTemplateName">
            <p-button label="Save" (onClick)="saveQuotationAsTemplate()"></p-button>
        </div>
    </p-dialog>
    <p-dialog header="Pre Confirmation Preview" [modal]="true"
        [(visible)]="bookingPreConfirmationService.displayPreConfirmationForm" [focusOnShow]="false">
        <app-create-booking-pre-confirmation (preConfirmationCreatedEvent)="handlePreConfirmationCreatedEvent($event)"
            *ngIf="bookingPreConfirmationService.displayPreConfirmationForm"></app-create-booking-pre-confirmation>
    </p-dialog>
    <div class="confirmation-main-container">
        <div class="confirmation-left-container">
            <h3 class="title">
                Booking information
            </h3>
            <table class="left-information-table">
                <col width="100">
                <col>
                <tr>
                    <td>School</td>
                    <td>
                        {{bookingService.booking.school.name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Destination
                    </td>
                    <td>
                        {{bookingService.booking.destination.name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Course
                    </td>
                    <td>
                        <p *ngIf="bookingService.booking.languageCourse">
                            {{bookingService.booking.languageCourse.descriptionFr}}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>Start date</td>
                    <td>
                        {{bookingService.booking.startDate.format('DD/MM/YYYY')}}
                    </td>
                </tr>
                <tr>
                    <td>
                        End date
                    </td>
                    <td>
                        {{bookingService.booking.endDate.format('DD/MM/YYYY')}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Duration
                    </td>
                    <td>
                        {{bookingService.booking.duration}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Accommodation
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.accommodationType.name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Room type
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.roomType.name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Board type
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.boardType.name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        TransferType
                    </td>
                    <td>
                        {{bookingService.booking.transferType!.name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Flight requested
                    </td>
                    <td>
                        <p *ngIf="bookingService.booking.flightRequested">
                            Yes
                        </p>
                        <p *ngIf="!bookingService.booking.flightRequested">
                            No
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        Cancellation Insurance
                    </td>
                    <td>
                        <p *ngIf="bookingService.booking.cancellationInsuranceRequested">
                            Yes
                        </p>
                        <p *ngIf="!bookingService.booking.cancellationInsuranceRequested">
                            No
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        Travel Insurance
                    </td>
                    <td>
                        <p *ngIf="bookingService.booking.travelInsuranceRequested">
                            Yes
                        </p>
                        <p *ngIf="!bookingService.booking.travelInsuranceRequested">
                            No
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        Promo code
                    </td>
                    <td>
                        {{bookingService.booking.promoCode}}
                    </td>
                </tr>
            </table>
            <h3 class="title">
                Student information
            </h3>
            <table class="left-information-table">
                <col width="100">
                <col>
                <tr>
                    <td>First name</td>
                    <td>
                        {{bookingService.booking.student.firstName}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Family name
                    </td>
                    <td>
                        {{bookingService.booking.student.lastName}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Language
                    </td>
                    <td>
                        {{bookingService.booking.student.language!.name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Gender
                    </td>
                    <td>
                        {{bookingService.booking.student.gender!.name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Birth date
                    </td>
                    <td>
                        <p *ngIf="bookingService.booking.student.birthDay">
                            {{bookingService.booking.student.birthDay.format('DD/MM/YYYY')}}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        Age (at departure)
                    </td>
                    <td>
                        {{bookingService.booking.ageAtStartDate}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Nationality
                    </td>
                    <td>
                        <p *ngIf="bookingService.booking.student.nationality">
                            {{bookingService.booking.student.nationality.name}}
                        </p>

                    </td>
                </tr>
                <tr>
                    <td>
                        Email
                    </td>
                    <td>
                        {{bookingService.booking.student.email}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Phone
                    </td>
                    <td>
                        {{bookingService.booking.student.phoneNumber}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Mobile
                    </td>
                    <td>
                        {{bookingService.booking.student.mobileNumber}}
                    </td>
                </tr>
            </table>
        </div>
        <div [formGroup]="bookingPreConfirmationService.preConfirmationForm" class="confirmation-right-container"
            *ngIf="bookingPreConfirmationService.preConfirmationForm">
            <div class="pre-confirmation-table-container">
                <div class="description-box">
                    <h3 class="title">
                        Description
                    </h3>
                    <input pInputText formControlName="description">
                </div>
                <div class="comment-box">
                    <h3 class="title">
                        Remarks
                    </h3>
                    <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
                </div>
                <div class="confirmation-options-container">
                    <div>
                        <p class="global-title">
                            Base currency
                        </p>
                        <p-dropdown [options]="currencyService.currencies" optionLabel="isoCode"
                            formControlName="baseCurrency" (onChange)="baseCurrencyUpdate()"
                            [style]="{'width':'100px','min-width':'100px'}">
                        </p-dropdown>
                    </div>
                    <div>
                        <p class="global-title">
                            2nd currency
                        </p>
                        <p-dropdown placeholder="--" [options]="currencyService.currencies" optionLabel="isoCode"
                            [style]="{'width':'100px','min-width':'100px'}" (onChange)="secondCurrencyUpdate()"
                            formControlName="secondCurrency" [showClear]="true"></p-dropdown>
                    </div>
                    <div>
                        <p class="global-title">
                            Confirmation date
                        </p>
                        <p-calendar [monthNavigator]="true" [yearRange]="bookingService.yearRange" [yearNavigator]="true"
                            formControlName="confirmationDate" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div>
                        <p class="global-title">
                            Balance due date
                        </p>
                        <p-calendar [monthNavigator]="true" [yearRange]="bookingService.yearRange" [yearNavigator]="true"
                            formControlName="dueDate" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div>
                        <p class="global-title">
                            Deposit(EUR)
                        </p>
                        <input pInputText formControlName="deposit">
                    </div>
                    <div>
                        <div *ngIf="bookingPreConfirmationService.preConfirmationForm">
                            Total
                            ({{bookingPreConfirmationService.preConfirmationForm.get('baseCurrency')!.value.isoCode}})
                            {{bookingPreConfirmationService.totalPriceInBaseCurrency.toFixed(0)}}
                            <div *ngIf="bookingPreConfirmationService.preConfirmationForm.get('secondCurrency')!.value">
                                Total
                                ({{bookingPreConfirmationService.preConfirmationForm.get('secondCurrency')!.value.isoCode}})
                                {{bookingPreConfirmationService.totalPriceInSecondCurrency.toFixed(0)}}
                            </div>
                            <div>
                                Cancellation
                                ({{bookingPreConfirmationService.preConfirmationForm.get('baseCurrency')!.value.isoCode}}):
                                {{bookingPreConfirmationService.totalGarantieAnnulationInBaseCurrency | decimalCeiling}}
                            </div>
                            <div *ngIf="bookingPreConfirmationService.preConfirmationForm.get('secondCurrency')!.value">
                                Cancellation
                                ({{bookingPreConfirmationService.preConfirmationForm.get('secondCurrency')!.value.isoCode}}):
                                {{bookingPreConfirmationService.totalGarantieAnnulationInSecondCurrency |
                                decimalCeiling}}
                            </div>
                        </div>
                    </div>
                </div>
                <table class="confirmation-transaction-table">
                    <tr class="first-table-row">
                        <th width="10">#</th>
                        <th width="175">Type</th>
                        <th class="description-th">Remarks</th>
                        <th>Price</th>
                        <th class="currency-th">Currency</th>
                        <!-- Base currency -->
                        <th class="currency-th">
                            {{bookingPreConfirmationService.preConfirmationForm.get('baseCurrency')!.value.isoCode}}</th>
                        <!-- Second currency -->
                        <th class="currency-th"
                            *ngIf="bookingPreConfirmationService.preConfirmationForm.get('secondCurrency')!.value">
                            {{bookingPreConfirmationService.preConfirmationForm.get('secondCurrency')!.value.isoCode}}
                        </th>
                        <th class="hover-menu-th">

                        </th>
                    </tr>
                    <tr formArrayName="products"
                        *ngFor="let product of productFormArray; let i = index"
                        (mouseenter)="mouseover(i)" (mouseleave)="mouseout(i)">
                        <td [formGroupName]="i">
                            {{i + 1}}
                        </td>
                        <td [formGroupName]="i">
                            <p-dropdown placeholder="Select" [options]="bookingPreConfirmationService.productTypes"
                                formControlName="type" optionLabel="name"
                                (onChange)="productTypeUpdate($event.value, i)" dataKey="id">
                                <ng-template pTemplate="item" let-item>
                                    {{item.name | titlecase}}
                                </ng-template>
                                <ng-template pTemplate="selectedItem" let-item>
                                    {{item.name | titlecase}}
                                </ng-template>
                            </p-dropdown>
                        </td>
                        <td [formGroupName]="i" class="description-container">
                            <textarea [rows]="1" pInputTextarea formControlName="description" [autoResize]="true"
                                id="description-input"></textarea>
                        </td>
                        <td [formGroupName]="i">
                            <input pInputText formControlName="amount" id="amount-input"
                                (blur)="onConfirmationAmountBlur()">
                        </td>
                        <td [formGroupName]="i">
                            <p-dropdown [style]="{'minWidth':'48px'}" [options]="currencyService.currencies"
                                formControlName="currency" (onChange)="onProductCurrencyUpdate()" optionLabel="isoCode"
                                (keydown.Tab)="pressTabOnCurrencyDropdown(i)"></p-dropdown>
                        </td>
                        <td *ngIf="bookingPreConfirmationService.productPriceInCurrency[i]">
                            {{bookingPreConfirmationService.productPriceInCurrency[i]}}
                        </td>
                        <td
                            *ngIf="bookingPreConfirmationService.preConfirmationForm.get('secondCurrency')!.value && 
                            bookingPreConfirmationService.productPriceInSecondCurrency[i]">
                            {{bookingPreConfirmationService.productPriceInSecondCurrency[i]}}
                        </td>
                        <td class="menu-head">
                            <table class="hover-menu"
                                *ngIf="getProductForms(i).get('activeMenu')!.value">
                                <tr>
                                    <td>
                                        <div class="icon-container">
                                            <i class="pi pi-caret-up"
                                                (click)="bookingPreConfirmationService.moveUp(i)"></i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="icon-container">
                                            <i class="pi pi-caret-down"
                                                (click)="bookingPreConfirmationService.moveDown(i)"></i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="icon-container">
                                            <i class="pi pi-plus-circle"
                                                (click)="bookingPreConfirmationService.insertItem(i)"></i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="icon-container">
                                            <i class="pi pi-times-circle"
                                                (click)="bookingPreConfirmationService.removeItem(i)"></i>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td [attr.colspan]="bookingPreConfirmationService.preConfirmationForm.get('secondCurrency')!.value?7:6">
                            <div class="no-record-row" (click)="bookingPreConfirmationService.insertItemToLast(bookingService.booking.preConfirmation!.confirmationDate!)">
                                <p class="no-record-message">
                                    Add record
                                </p>
                                <div class="icon-wrap">
                                    <i class="pi pi-plus"></i>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="price-includes-container">
                <div class="price-includes-editor-container">
                    <p class="global-title">
                        Prices include
                    </p>
                    <ckeditor [editor]="Editor" formControlName="priceIncludes"></ckeditor>
                </div>
                <div class="price-includes-editor-container">
                    <p class="global-title">
                        Prices do not includes
                    </p>
                    <ckeditor [editor]="Editor" formControlName="priceNotIncludes"></ckeditor>
                </div>
            </div>
            <div *ngIf="bookingService.booking.salesAgent.id==5" class="middle-comment-container">
                <p>Comment</p>
                <textarea pInputTextarea formControlName="middleComment" class="middle-comment-input"></textarea>
            </div>
            <div class="payment-account-container">
                Selected account:
                <p-dropdown dataKey="id" placeholder="Select recipient bank"
                    [options]="bookingPreConfirmationService.bankInformations" optionLabel="label"
                    formControlName="selectedBank"></p-dropdown>
            </div>
        </div>
    </div>
</div>